module.exports = __webpack_public_path__ + "static/media/2.70847b89.jpg";